"use client";

import { useState } from "react";
import { Button, Link } from "@zapier/design-system";
import { useTranslations } from "@zapier/i18n";

import { TRASH_HREF } from "../AssetLayout/trashHref";
import styles from "./TrashNotification.module.css";

interface Props {
  /** Omitted when the trashed item(s) can't be restored (e.g. project Zaps). */
  onUndo?: () => void;
}

/**
 * The "moved to trash" success toast actions: Undo and View trash.
 * The message itself is passed as the notification's `title`, not here.
 */
export function TrashNotification({ onUndo }: Props) {
  const t = useTranslations("buttons");
  const [isUndoing, setIsUndoing] = useState(false);

  return (
    <div className={styles.actions}>
      {onUndo && (
        <Button
          variant="tertiary"
          size="small"
          isDisabled={isUndoing}
          onPress={() => {
            // One-shot: a second click can't retrigger the restore.
            setIsUndoing(true);
            onUndo();
          }}
        >
          {t("restore-undo")}
        </Button>
      )}
      <Link href={TRASH_HREF} variant="primary" size="small">
        {t("view-trash")}
      </Link>
    </div>
  );
}
